import {
  //neo
  SET_MASTER_DATA,
  SET_FULL_DATA,
  SET_PACKAGES_DATA,
  SET_SINGLECOSMETIC_DATA,
  SET_CUSTOMER_PERSONAL_INFO,
  SET_CHECKOUT_TYPE,
  SET_SINGLETREAT_DATA,
  SET_SPA_URL,
  SET_USER_FAVS,
  SET_USER_CART,
  SET_SHOW_X,
  SET_TOKEN,
  SET_TREATMENT_REVEAL,
  SET_LOCAL_PROPERTIES,
  SET_SPA_NAME,
  SET_ONSITE_RETURN_CART,
} from "./actionTypes";

// "https://onlinedemo.atlantis.aegeospas.gr/proxy",
const getInitialState = () => ({
  FullData: null,
  MasterData: null,
  PackagesData: null,

  SingleCosmData: null,
  SingleCosmQuontity: null,
  CustomerPersonalInfo: null,

  CheckOutType: null,
  SingleTreatData: null,

  //state.LocalProperties.Iframe_Special_Messages[0][0].Message
  LocalProperties: null,

  UserFavs: [],
  UserCart: [],

  BookingDelay: 0, //Se ores! Ella: 120 λεπτά , DivaniApollon: 0
  AllowedForwardMonths:5, // Ella: 0 , DivaniApollon: 5
  SlackDays: 1, // CalendarCore.jsx // Ella: 0, DivaniApollon: 1
  PayOnSite: -1, // Pay-on-site button reveal for how many days!

  RevealTreatments: false,
  //https://proxy.spaonline.gr/api/treatments/divaniapollon
  AegeoAPI: "https://proxy.spaonline.gr", //"http://localhost:52737/",
  SpaName: 'Parocks',//'DivaniApollon', //hardcode ---> DivaniApollon ----> Ella ----> OlympianVillage
  hardcode: 'Parocks',//'DivaniApollon', //,,, Authenticate.js ,,, 
  Images: "img/",
  AegeoImgUrl: "https://onlinedemo.atlantis.aegeospas.gr/img/", //Older+
  Treatments: "api/proxy/treatments",
  Availability: "api/proxy/treatmentavailability",
  Properties: "api/proxy/properties/0", //const!!!
  ShoppingCart: "api/proxy/shoppingcart",
  // UserName: "aegeo",
  // Password: "4f8c15cb-4155-4ee0-89fa-ea8b52f7fa1d",
  UserName: "atlantis",
  Password: "76d3da81-b919-4af1-b491-c5cb313cfb6c",
  PropertyCode: "Parocks",//"DivaniApollon",//hardcode
  Token: false,
  API_login: "api/login",
  // API_login: "https://proxy.spaonline.gr/api/login",

  ShowX: false,
});

const initialState = getInitialState();

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    // from cartActions we recieve return:ADD_ITEM, return:DELETE_ITEM, e.c.t
    //Neo
    case SET_ONSITE_RETURN_CART:
      //code here(Extra code)
      return {
        ...state,
        OnSiteReturnCart: action.param,
      };

    case SET_SPA_NAME:
      //code here(Extra code)
      return {
        ...state,
        // SpaName: action.param,
      };
    case SET_FULL_DATA:
      //code here(Extra code)
      return {
        ...state,
        FullData: action.param,
      };
    case SET_MASTER_DATA:
      //code here(Extra code)
      return {
        ...state,
        MasterData: action.param,
      };
    case SET_PACKAGES_DATA:
      //code here(Extra code)
      return {
        ...state,
        PackagesData: action.param,
      };
    case SET_SINGLECOSMETIC_DATA:
      //code here(Extra code)
      return {
        ...state,
        SingleCosmData: action.param[0],
        SingleCosmQuontity: action.param[1],
      };
    case SET_CUSTOMER_PERSONAL_INFO:
      //code here(Extra code)

      return {
        ...state,
        CustomerPersonalInfo: action.param,
      };
    case SET_CHECKOUT_TYPE:
      //code here(Extra code)

      return {
        ...state,
        CheckOutType: action.param,
      };
    case SET_CHECKOUT_TYPE:
      //code here(Extra code)

      return {
        ...state,
        CheckOutType: action.param,
      };
    case SET_SINGLETREAT_DATA:
      //code here(Extra code)

      return {
        ...state,
        SingleTreatData: action.param,
      };
    case SET_SPA_URL:
      //code here(Extra code)

      if (action.param != undefined) {
        // alert("REDUSER = " + action.param);
        return {
          ...state,
          SpaName: action.param,
          PropertyCode: action.param,
        };
      }
    case SET_USER_FAVS:
      //code here(Extra code)

      return {
        ...state,
        UserFavs: action.param,
      };
    case SET_USER_CART:
      //code here(Extra code)

      return {
        ...state,
        UserCart: action.param,
      };
    case SET_SHOW_X:
      //code here(Extra code)

      return {
        ...state,
        ShowX: action.param,
      };
    case SET_TOKEN:
      //code here(Extra code)

      return {
        ...state,
        Token: action.param,
      };
    case SET_TREATMENT_REVEAL:
      //code here(Extra code)

      return {
        ...state,
        RevealTreatments: action.param,
      };
    case SET_LOCAL_PROPERTIES:
      //code here(Extra code)

      return {
        ...state,
        LocalProperties: action.param,
      };

    default:
      return state;
  }
};
export default cartReducer;
